<template>
    <v-container fluid style="margin-top: -12px;">
        <v-progress-linear indeterminate  v-if="isLoading"></v-progress-linear>
    <Pie  v-if="!isLoading"
      :chart-options="chartOptions"
      :chart-data="chartData"
      :dataset-id-key="datasetIdKey"
      :plugins="plugins"
      :css-classes="cssClasses"
      :styles="styles"
      :width="width"
      :height="height"
    />
    </v-container>
  </template>
  
  <script>
 

  import BaseModule from '../../../common/BaseModule.js'
  import ChartBaseModule from './ChartBaseModule.js'

  import { Pie } from 'vue-chartjs/legacy'

import {
  Chart as ChartJS,
  Title,
  Tooltip,
  Legend,
  ArcElement,
  CategoryScale
} from 'chart.js'

ChartJS.register(Title, Tooltip, Legend, ArcElement, CategoryScale)

  export default {
    name: 'PieChart',
    mixins: [BaseModule, ChartBaseModule],
    components: {
      Pie
    },
    mounted() {
        this.update();
    },
    methods: {

    },
    data() {
      return {
       
      }
    }
  }
  </script>
  